export function filterArray(servId, arr) {
  return filterArrayById(servId, arr)
}
/**
 * @description: 递归查询多维数组
 * @param {string} servId  根据此值查找需要的对象数组
 * @param {array} arr      需要遍历的数组
 * @returns {object}
 */
function filterArrayById(servId, arr) {
  for (const item of arr) {
    if (item.servId == servId) {
      return item
    }
    if (item.children && item.children.length) {
      const _item = filterArrayById(servId, item.children)
      if (_item) {
        return _item
      }
    }
  }
  return false
}


// 金额格式化
export function parseMoney(amount) {
  if (!amount) {
    return "0.00"
  }
  //强制保留两位小数
  let f = parseFloat(amount);
  if (isNaN(f)) return false;
  f = Math.round(amount * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length < (rs + 1) + 2) {
    s += '0';
  }
  //每三位用一个逗号隔开
  let leftNum = s.split(".")[0];
  let rightNum = "." + s.split(".")[1];
  let result;
  //定义数组记录截取后的价格
  let resultArray = new Array();
  if (leftNum.length > 3) {
    let i = true;
    while (i) {
      resultArray.push(leftNum.slice(-3));
      leftNum = leftNum.slice(0, leftNum.length - 3);
      if (leftNum.length < 4) {
        i = false;
      }
    }
    //由于从后向前截取，所以从最后一个开始遍历并存到一个新的数组，顺序调换
    let sortArray = new Array();
    for (let i = resultArray.length - 1; i >= 0; i--) {
      sortArray.push(resultArray[i]);
    }
    result = leftNum + "," + sortArray.join(",") + rightNum;
  } else {
    result = s;
  }
  return result.replace("-,", "-");
}


// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function getFileType(filePath) {
  var startIndex = filePath.lastIndexOf(".");
  if (startIndex != -1)
    return filePath.substring(startIndex + 1, filePath.length);
  else return "未知类型";

}

export function getFileName(filePath) {
  var startIndex = filePath.lastIndexOf("/");
  if (startIndex != -1) {
    return filePath.substring(startIndex + 1, filePath.length);
  } else {
    return "未知名称";
  }
}
export function renameFileName(filePath) {
  var startIndex = filePath.lastIndexOf("/");
  if (startIndex != -1) {
    startIndex = filePath.lastIndexOf("/", startIndex - 1);
    if (startIndex != -1) {
      startIndex = filePath.lastIndexOf("/", startIndex - 1);
    }
  }
  let tempName = "未知名称"
  tempName = filePath.substring(startIndex + 1, filePath.length);
  tempName = tempName.split("/");
  let name = '未知类型';
  if (filePath.lastIndexOf("scan") != -1) {
    name = "口扫数据";
  } else if (filePath.lastIndexOf("sheet") != -1) {
    name = "设计单照片";
  } else if (filePath.lastIndexOf("mouth") != -1) {
    name = "口内照片";
  } else if (filePath.lastIndexOf("cbct") != -1) {
    name = "CBCT数据";
  } else if (filePath.lastIndexOf("design") != -1) {
    name = "设计文件";
  } else if (filePath.lastIndexOf("report") != -1) {
    name = "手术报告";
  } else if (filePath.lastIndexOf("guide") != -1) {
    name = "钻针指南文件";
  } else if (filePath.lastIndexOf("make") != -1) {
    name = "制造文件";
  }
  name = tempName[0] + "_" + name
  return name;
}

export function noPassByName(str) {
  if (null != str && str != undefined) {
    if (str.length == 2) {
      return str.substring(0, 1) + '*' //截取name 字符串截取第一个字符，
    } else if (str.length == 3) {
      return str.substring(0, 1) + "*" + str.substring(2, 3) //截取第一个和第三个字符
    } else if (str.length > 3) {
      return str.substring(0, 1) + "*" + '*' + str.substring(3, str.length) //截取第一个和大于第4个字符
    }
  } else {
    return "";
  }
}
// 隐藏订单信息信息
export function hideInfo(str) {
  if (str.length == 2) {
    return str.substring(0, 1) + '*';
  } else if (str.length == 3) {
    return str.substring(0, 1) + '*' + str.substring(2, 3);
  } else if (str.length == 11) {
    return str.substring(0, 3) + '****' + str.substring(7, 11);
  } else {
    let temp = ''
    for (let i = 0; i < str.length - 2; i++) {
      temp += '*'
    }
    return str.substring(0, 1) + temp + str.substring(str.length - 2, 1);
  }
}

export function timeFormat(times) {
  // 个位补零
  const addZero = (d) => parseInt(d, 10) < 10 ? "0" + d : d;
  if (times > 0) {
    let days = addZero(
      Math.floor(times / 1000 / 60 / 60 / 24)
    );
    let hours = addZero(
      Math.floor((times / 1000 / 60 / 60) % 24)
    );
    let minutes = addZero(
      Math.floor((times / 1000 / 60) % 60)
    );
    let seconds = addZero(
      Math.floor((times / 1000) % 60)
    );
    if (days == '00' && hours != '00') {
      return `${hours}时${minutes}分${seconds}秒`;
    } else if (days == '00' && hours == '00') {
      return `${minutes}分${seconds}秒`;
    } else {
      return `${days}天${hours}时${minutes}分${seconds}秒`;
    }
  } else {
    return "已超时";
  }
}




// WEBPACK FOOTER //
// ./src/utils/utils.js